/**
 * Centralized external link config.
 * Update the constant here once if the destination URL ever changes —
 * every CTA button on the site reads from this file.
 */

// Houston Apartment Match Quiz (Typeform). Public form URL.
// Previous value: internal popup embed using form ID 01KSR618J22928PPVGXE2VHDG8 (broken, redirected to typeform.com homepage).
export const TYPEFORM_QUIZ_URL = "https://form.typeform.com/to/HVW8nyIK";
